module.exports = __webpack_public_path__ + "files/761f8355cd0c676f4ad242bdc1c06097.png";


//////////////////
// WEBPACK FOOTER
// ./images/icons/patch.png
// module id = 311
// module chunks = 60